import React from "react";
import Activity from "../Activity/Activity";
import { getDate } from "../../../../common/DateUtils";

// Styles
import "./DayWiseActivities.scss";

const DayWiseActivities = ({
  activities,
  date,
  handleDocumentView,
  currentUserInfo,
  isAllActivityRead,
  setNewActivitiesCount,
}) => {
  return (
    <div className="activity-day">
      <span className="activity-day-title">{getDate(date, "mmm d", true)}</span>
      {activities.map((activity) => (
        <Activity
          key={activity.id}
          {...{ activity, currentUserInfo, isAllActivityRead, setNewActivitiesCount, handleDocumentView }}
        />
      ))}
    </div>
  );
};

export default DayWiseActivities;
